import mainConstants from './mainConstants';
import appConstants from './appConstants';

export const main = mainConstants;
export const app = appConstants;